import { onKeyDown } from "@prezly/slate-lists";
import type React from "react";
import type { Editor } from "slate";

import { Helpers } from "../helpers";
import { NodeTypes } from "../slateTypes";

export const useKeyDown = (
  editor: Editor,
  {
    toggleShortcuts,
    setUrl,
  }: {
    toggleShortcuts: () => void;
    setUrl: (url: string) => void;
  },
) => {
  const keydownHandler = (event: React.KeyboardEvent) => {
    // command
    if (event.ctrlKey || event.metaKey) {
      switch (event.code) {
        case "KeyB":
          event.preventDefault();
          Helpers.toggleMark(editor, "strong");
          break;
        case "KeyI":
          event.preventDefault();
          Helpers.toggleMark(editor, "emphasis");
          break;
        case "KeyK":
          event.preventDefault();
          Helpers.prepareLink(editor, setUrl);
          break;
        case "Slash":
          event.preventDefault();
          toggleShortcuts();
          break;
      }
    }

    // shift + command
    if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
      switch (event.code) {
        case "Digit8":
          event.preventDefault();
          Helpers.toggleList(editor, NodeTypes.UNORDERED_LIST);
          break;
        case "Digit7":
          event.preventDefault();
          Helpers.toggleList(editor, NodeTypes.ORDERED_LIST);
          break;
      }
    }

    // command + alt
    if ((event.ctrlKey || event.metaKey) && event.altKey) {
      event.preventDefault();
      switch (event.code) {
        case "Digit0":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.PARAGRAPH);
          break;
        case "Digit1":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.HEADING, 1);
          break;
        case "Digit2":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.HEADING, 2);
          break;
        case "Digit3":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.HEADING, 3);
          break;
        case "Digit4":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.HEADING, 4);
          break;
        case "Digit5":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.HEADING, 5);
          break;
        case "Digit6":
          event.preventDefault();
          Helpers.toggleBlock(editor, NodeTypes.HEADING, 6);
          break;
      }
    }

    // if list item
    if (Helpers.isElement(editor, NodeTypes.LIST_ITEM_TEXT)) {
      onKeyDown(editor as any, event);
    }
    if (event.code === "Tab") {
      event.preventDefault();
    }
  };

  return { keydownHandler };
};
